import type { IconName } from "../components/icon/Icon";

export const integrationsIcons: Record<string, IconName> = {
  mail: "mail",
  word: "wordLogo",
  excel: "excelLogo",
  task: "clipboardCheck",
  googlesheetupdate: "googleSheetsLogo",
  googlesheets: "googleSheetsLogo",
  onedrive: "oneDriveLogo",
  delete: "trash",
  sftp: "database",
  mongodbinsert: "mongoDBLogo",
  webdav: "webDAVLogo",
};
